import TENANTS, { TENANT_CHIP_LABELS } from '~/consts/tenant';

type UserIdentitySource = {
  email?: unknown;
  tenant?: unknown;
  result?: {
    tenant?: unknown;
  } | null;
};

function asNonEmptyString(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

/**
 * svc-auth user search responses are in transition: tenant may be supplied on
 * the summary itself or in its nested result object.
 */
export function getUserTenant(user: UserIdentitySource): string | undefined {
  return asNonEmptyString(user.tenant) ?? asNonEmptyString(user.result?.tenant);
}

export function getUserTenantTitle(user: UserIdentitySource): string | undefined {
  const tenant = getUserTenant(user);
  return tenant ? (TENANT_CHIP_LABELS[tenant] ?? TENANTS[tenant]?.title ?? tenant) : undefined;
}

export function formatUserSelectionLabel(user: UserIdentitySource): string {
  const email = asNonEmptyString(user.email) ?? '';
  const tenantTitle = getUserTenantTitle(user);

  if (!tenantTitle) {
    return email;
  }

  return email ? `${email} — ${tenantTitle}` : tenantTitle;
}
